import type { DataProvider } from '@refinedev/core';
import { http } from './client.js';

/**
 * Refine data provider 适配后端 /v1/<resource> 风格 API
 *
 * 后端响应格式：{ rows, total, page, pageSize }
 * Refine 需求格式：{ data, total }
 */
export const dataProvider: DataProvider = {
  getApiUrl: () => http.defaults.baseURL ?? '',

  async getList({ resource, pagination, sorters, filters }) {
    const page = pagination?.current ?? 1;
    const pageSize = pagination?.pageSize ?? 50;
    const params: Record<string, unknown> = { page, pageSize };
    if (sorters?.length) {
      const s = sorters[0];
      if (s) {
        params.orderBy = s.field;
        params.order = s.order;
      }
    }
    for (const f of filters ?? []) {
      if ('field' in f && f.value !== undefined) {
        params[`filter[${f.field}]`] = f.value;
      }
    }
    const { data } = await http.get(`/${resource}`, { params });
    return { data: data.rows ?? [], total: data.total ?? 0 };
  },

  async getOne({ resource, id }) {
    const { data } = await http.get(`/${resource}/${id}`);
    return { data };
  },

  async create({ resource, variables }) {
    const { data } = await http.post(`/${resource}`, variables);
    return { data };
  },

  async update({ resource, id, variables }) {
    const { data } = await http.patch(`/${resource}/${id}`, variables);
    return { data };
  },

  async deleteOne({ resource, id }) {
    await http.delete(`/${resource}/${id}`);
    return { data: { id } as unknown as never };
  },

  async getMany({ resource, ids }) {
    const all = await Promise.all(ids.map((id) => http.get(`/${resource}/${id}`)));
    return { data: all.map((r) => r.data) };
  },

  async custom({ url, method, payload, query }) {
    const { data } = await http.request({
      url,
      method: method ?? 'get',
      data: payload,
      params: query,
    });
    return { data };
  },
};
